<!-- A heading for a group of rows. Factory-owned. Styles in kit.css.

     A real heading (h2), not an uppercase label floating over a list. `count`
     is shown beside it in the dim ink; a trailing action (one link-weight
     button) goes in the default slot. -->
<template>
  <div class="kit-section">
    <h2 class="kit-section__title">
      {{ title }}<span v-if="count !== null && count !== undefined" class="kit-section__count">{{ count }}</span>
    </h2>
    <slot />
  </div>
</template>

<script setup>
defineProps({
  title: { type: String, required: true },
  count: { type: [Number, String], default: null },
});
</script>
